import UserGetters from "./UserGetters";
import UserActions from "./UserActions";
import UserMutations from "./UserMutations";
import UsersService from "@/services/common/UsersService";
import UserPreferencesModule from "./userPreferences/UserPreferencesModule";

// #endregion

const state = UsersService.EmptyUserStateFactory();

const { getters } = UserGetters;

const { actions } = UserActions;

const { mutations } = UserMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	getters,
	actions,
	mutations,
	modules: { UserPreferencesModule },
};
